import NftSelector from "./NftSelector";
import React from "react";
import { WalletContext } from "./App";

export default function WalletInfo() {
    const wallet = React.useContext(WalletContext);
    return (
        wallet.player.nfts === undefined ? <div style={{height: '120px'}}><p style={{textAlign: 'center'}}>loading NFTs...</p></div> :
            <div style={{marginBottom: '10px'}}>
                <p style={{textAlign: "center"}}>
                    <b>Your wallet:</b> {wallet.player.nfts.length} ApexDucks / {wallet.player.sol} SOL
                </p>
                <NftSelector message={'Select a duck to play'} pagesize={3}/>
            </div>
    );
}
